<div class="student-loading">
  <!-- Loading state -->
  <div class="loading-content" *ngIf="loading">
    <mat-spinner mode="indeterminate" [diameter]="48"></mat-spinner>
    <p class="loading-text">{{'game-mode.student-loading.loading' | translate}}</p>
  </div>

  <!-- Student checklist -->
  <ng-container *ngIf="!loading">
    <button class="back-btn" (click)="goBack()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <h2 class="picker-title">{{'game-mode.student-loading.title' | translate}}</h2>
    <p class="picker-subtitle">{{selectedCount | arabicNumber:currLang}} / {{students.length | arabicNumber:currLang}} {{'game-mode.student-loading.selected' | translate}}</p>

    <div class="students-list">
      <div *ngFor="let student of students"
           class="student-row"
           [class.unselected]="!student.selected"
           (click)="toggleStudent(student)">
        <div class="student-info">
          <div class="student-avatar">
            <img *ngIf="hasCustomImage(student.image_path)"
                 [src]="getImageUrl(student.image_path)"
                 class="avatar-img" alt="" />
            <img *ngIf="!hasCustomImage(student.image_path)"
                 src="assets/images/avatar.png"
                 class="avatar-img" alt="" />
          </div>
          <span class="student-name">{{student.name}}</span>
        </div>
        <div class="check-circle" [class.checked]="student.selected">
          <svg *ngIf="student.selected" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17L4 12" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>

    <button class="confirm-btn" (click)="confirm()" [disabled]="selectedCount === 0">
      {{'game-mode.student-loading.confirm' | translate}}
    </button>
  </ng-container>
</div>
